const regexConstants = {
  urlRegex: /(https?:\/\/\S+)/g,
};

export default regexConstants;
